import { httpsCallable } from 'firebase/functions';
import { functions } from './firebaseFunctions';
import type {
  ApplyArTableSortAsOrderRequest,
  ComputeAggregationsRequest,
  ArTableRowOperationsRequest,
  ArTableRowOperationsResponse,
  ArTableRowUndoRequest,
  ArTableRowUndoResponse,
  GetArTablePageCursorRequest,
  GetArTablePageCursorResponse,
  ExportArTableRowsRequest,
  ExportArTableRowsResponse,
} from '#types/System.Artifacts.types';

export async function applyArTableSortAsOrder(
  request: ApplyArTableSortAsOrderRequest
): Promise<void> {
  const call = httpsCallable<ApplyArTableSortAsOrderRequest, void>(
    functions,
    'applyArTableSortAsOrder'
  );
  await call(request);
}

export async function computeAggregations(
  request: ComputeAggregationsRequest
): Promise<{ skipped: boolean; computed: number }> {
  const call = httpsCallable<ComputeAggregationsRequest, { skipped: boolean; computed: number }>(
    functions,
    'computeAggregations'
  );
  return (await call(request)).data;
}

export async function getArTablePageCursor(
  request: GetArTablePageCursorRequest
): Promise<GetArTablePageCursorResponse> {
  const call = httpsCallable<GetArTablePageCursorRequest, GetArTablePageCursorResponse>(
    functions,
    'getArTablePageCursor'
  );
  return (await call(request)).data;
}

export async function arTableRowOperations(
  request: ArTableRowOperationsRequest
): Promise<ArTableRowOperationsResponse> {
  const call = httpsCallable<ArTableRowOperationsRequest, ArTableRowOperationsResponse>(
    functions,
    'arTableRowOperations'
  );
  return (await call(request)).data;
}

export async function arTableRowUndo(
  request: ArTableRowUndoRequest
): Promise<ArTableRowUndoResponse> {
  const call = httpsCallable<ArTableRowUndoRequest, ArTableRowUndoResponse>(
    functions,
    'arTableRowUndo'
  );
  return (await call(request)).data;
}

export async function exportArTableRows(
  request: ExportArTableRowsRequest
): Promise<ExportArTableRowsResponse> {
  const call = httpsCallable<ExportArTableRowsRequest, ExportArTableRowsResponse>(
    functions,
    'exportArTableRows'
  );
  return (await call(request)).data;
}

